module.exports = __webpack_public_path__ + "img/orderAnalyModel1.5fc0df54.png";